/** Tenant 360: several active journeys for one customer — kept as separate ONE Flow strips (never merged into one line). */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import OneFlow from "@/components/oneflow/OneFlow";

export default function CustomerFlows({ masterClientId }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/one-flow/record/CUSTOMER/${masterClientId}/related`).then((r) => setData(r.data)).catch(() => setData({ journeys: [] })); }, [masterClientId]);
  if (!data) return <div className="h-10 rounded-xl bg-slate-50 animate-pulse" data-testid="customer-flows-loading" />;
  if (!data.journeys?.length) return <div className="text-[11px] text-slate-400" data-testid="customer-flows-empty">No active ONE Flow journeys for this customer yet.</div>;
  return (
    <div className="space-y-2" data-testid="customer-flows">
      <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400 font-semibold">Active journeys</div>
      {data.journeys.map((j) => <OneFlow key={`${j.flow_type}-${j.record_id}`} flowType={j.flow_type} recordId={j.record_id} title={`${j.flow_name} · ${j.record?.code || ""}`} />)}
    </div>
  );
}
